import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import Highlight from "react-highlighter";
import { DATETIME } from "../../../utils/dateFormats";

class Header extends React.Component {
  render() { 
    const {
      searchString,
      userId,
      userName,
      messageType,
      created,
      destroyMessage,
      message,
      currentUserIsAdmin
    } = this.props;

    return (
      <div className="row">
        <div className="col-md-6 col-xs-12">
          {moment(created).format(DATETIME)} | &nbsp;
          <a className="styled-link" href={`/users/${userId}`}>
            <Highlight matchClass="highlighted" search={searchString}>
              {userName}
            </Highlight>
          </a>
        </div>

        <div className="col-md-5 col-xs-11">
          <span className="label label-success pull-right">{messageType}</span>
        </div>

        {currentUserIsAdmin &&
          <div className="col-md-1 col-xs-1 pull-right">
            <button onClick={destroyMessage} 
                    id={message.id} 
                    className="btn btn-text pull-right"
                    style={{ marginTop: "-10px" }}
                    >
              DELETE
            </button>
          </div>
        }
      </div>
    );
  }
}

Header.propTypes = {
  searchString: PropTypes.string,
  userId: PropTypes.number,
  created: PropTypes.string,
  userName: PropTypes.string,
  messageType: PropTypes.string
};

export default Header;
